module.exports = __webpack_public_path__ + "img/mouse1.a74ff490.png";